export const es_policies = {
  refund: {
    title: "Política de Reembolso",
    backToCheckout: "Volver al pago",
    backToHome: "Volver al inicio",
    setupFeeNotice: "La tarifa de configuración de €500 no es reembolsable una vez que el desarrollo haya comenzado.",
    subscriptionNotice: "Los pagos de suscripción no son reembolsables para los períodos facturados.",
    exceptionalCircumstances: "Circunstancias Excepcionales",
    exceptionalText: "Dathent mantiene autoridad discrecional en circunstancias excepcionales.",
    processTitle: "Proceso de Reembolso",
    processText: "Si cree que tiene un caso válido para una excepción de reembolso, contáctenos en:",
    earlyTerminationTitle: "Terminación Anticipada",
    earlyTerminationText: "Para obtener información sobre la terminación anticipada del Modelo de Compromiso de Infraestructura, consulte los",
    termsLink: "Términos de Servicio",
    lastUpdated: "Última actualización: Febrero 2026"
  },
  privacy: {
    title: "Política de Privacidad",
    backToCheckout: "Volver al pago",
    backToHome: "Volver al inicio",
    dataControllerTitle: "Responsable del Tratamiento",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), España",
    dataCollectedTitle: "Datos Recopilados",
    dataCollectedText: "Recopilamos y procesamos las siguientes categorías de datos personales:",
    contactDetails: "Datos de contacto (nombre, correo electrónico, teléfono)",
    projectInfo: "Información del proyecto",
    commHistory: "Historial de comunicación",
    purposeTitle: "Finalidad",
    purposeText: "Los datos se procesan estrictamente para:",
    serviceDelivery: "Prestación de servicios",
    clientComm: "Comunicación con clientes",
    paymentProcessing: "Procesamiento de pagos",
    operationalImprovement: "Mejora operativa",
    paymentSecurityTitle: "Seguridad de Pagos",
    paymentSecurityText1: "Los pagos se procesan a través de",
    paymentSecurityText2: "Dathent no almacena información de tarjetas de pago.",
    dataRightsTitle: "Derechos sobre los Datos",
    dataRightsText: "De acuerdo con el RGPD, los clientes pueden solicitar:",
    accessRight: "Acceso a sus datos personales",
    rectificationRight: "Rectificación de datos inexactos",
    erasureRight: "Eliminación de datos personales",
    restrictionRight: "Restricción del procesamiento",
    requestsLabel: "Solicitudes:",
    dataRetentionTitle: "Retención de Datos",
    dataRetentionText: "Los datos personales se conservan solo el tiempo necesario para los fines descritos anteriormente, o según lo requiera la ley aplicable.",
    thirdPartySharingTitle: "Compartir Datos con Terceros",
    thirdPartySharingText: "No vendemos ni compartimos datos personales con terceros, excepto cuando sea necesario para la prestación de servicios (p. ej., procesamiento de pagos a través de Stripe).",
    contactTitle: "Contacto",
    contactText: "Para cualquier consulta relacionada con la privacidad, póngase en contacto con:",
    lastUpdated: "Última actualización: Febrero 2026"
  },
  terms: {
    title: "Términos de Servicio",
    backToCheckout: "Volver al pago",
    backToHome: "Volver al inicio",
    companyTitle: "1. Empresa",
    companyText: "Este sitio web y los servicios relacionados son operados por:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), España",
    companyNote: "Servicios prestados bajo la ley española y registrados en el Registro Mercantil de Alicante.",
    companyDesc: "Dathent proporciona soluciones estructuradas de infraestructura web y soporte técnico a largo plazo para empresas.",
    serviceModelsTitle: "2. Modelos de Servicio",
    serviceModelsText: "Dathent ofrece dos modelos comerciales:",
    fullDevTitle: "A. Modelo de Desarrollo Completo",
    fullDevPrice: "Pago único: €1500",
    fullDevNoSubscription: "Sin compromiso de suscripción.",
    fullDevDesc: "Este modelo incluye la entrega completa del sitio web sin obligación de soporte a largo plazo.",
    infraCommitTitle: "B. Modelo de Compromiso de Infraestructura",
    infraSetup: "Configuración inicial: €500",
    infraSupport: "Soporte continuo de infraestructura: €50 por mes",
    infraMinimum: "Compromiso mínimo: 12 meses",
    infraDesc: "Este modelo proporciona un precio de desarrollo con descuento a cambio de un acuerdo de soporte a largo plazo estructurado.",
    infraNote: "La tarifa de soporte estándar es de €150 por mes. La tarifa de €50 es un incentivo contractual vinculado al compromiso de 12 meses.",
    commercialStructureTitle: "3. Estructura Comercial",
    commercialPoint1: "La tarifa de desarrollo con descuento (€500) no es un producto independiente.",
    commercialPoint2: "Es parte de un acuerdo de infraestructura estructurado.",
    commercialPoint3: "El valor económico del desarrollo permanece en €1500.",
    commercialPoint4: "El precio de entrada reducido se otorga en consideración del compromiso de 12 meses.",
    earlyTerminationTitle: "4. Terminación Anticipada",
    earlyTerminationText: "Si el cliente rescinde el acuerdo de soporte antes de completar 12 meses, el valor económico restante vence.",
    calculationTitle: "Cálculo:",
    fullDevValue: "Valor de desarrollo completo: €1500",
    paidAtSetup: "Cantidad pagada en la configuración: €500",
    outstandingBalance: "Saldo pendiente: €1000",
    settlementNote: "Tras la liquidación de este saldo, el acuerdo de soporte termina y no se aplican más cargos mensuales.",
    deliveryFrameworkTitle: "5. Marco de Entrega",
    deliveryText: "El desarrollo comienza después de la confirmación del pago y la recepción de los materiales requeridos.",
    deliveryTime: "Tiempo de entrega típico: desde 1 semana.",
    acceleratedDelivery: "La entrega acelerada puede ser posible dependiendo del alcance del proyecto.",
    timelinesDepend: "Los plazos dependen de la capacidad de respuesta del cliente y la complejidad del proyecto.",
    intellectualPropertyTitle: "6. Propiedad Intelectual",
    ipText: "La plena propiedad del sitio web desarrollado se transfiere al completar las obligaciones económicas bajo:",
    ip12Months: "Compromiso de infraestructura de 12 meses",
    ipOr: "O",
    ipFullPayment: "Pago completo del valor total de €1500",
    limitationTitle: "7. Limitación de Responsabilidad",
    limitationText: "DATHENT SAX S.L. no es responsable de:",
    thirdPartyInterruptions: "Interrupciones de servicios de terceros",
    hostingFailures: "Fallos del proveedor de hosting",
    clientDelays: "Retrasos causados por información incompleta del cliente",
    limitationNote: "La responsabilidad se limita al valor del servicio adquirido.",
    governingLawTitle: "8. Ley Aplicable",
    governingLawText: "Estos Términos se rigen por las leyes de España.",
    lastUpdated: "Última actualización: Febrero 2026"
  },
  subscriptionPolicy: {
    title: "Acuerdo de Suscripción",
    backToCheckout: "Volver al pago",
    backToHome: "Volver al inicio",
    infraSupportTitle: "1. Soporte de Infraestructura",
    infraSupportText: "El servicio de soporte de infraestructura garantiza:",
    techStability: "Estabilidad técnica",
    continuousMaintenance: "Mantenimiento continuo",
    minorAdjustments: "Ajustes funcionales menores",
    monitoring: "Supervisión y control de rendimiento",
    standardRate: "Tarifa estándar: €150 por mes.",
    discountedRateTitle: "2. Tarifa de Compromiso con Descuento",
    discountedRateText: "La tarifa de €50/mes se otorga exclusivamente bajo el Modelo de Compromiso de Infraestructura.",
    minimumTerm: "Plazo mínimo: 12 meses.",
    discountedRateNote: "La tarifa con descuento refleja una estructura de cooperación a largo plazo.",
    billingStructureTitle: "3. Estructura de Facturación",
    billing30Days: "La facturación comienza 30 días después del pago de configuración inicial.",
    billingStripe: "Los pagos se procesan de forma segura a través de Stripe.",
    earlyExitTitle: "4. Cláusula de Salida Anticipada",
    earlyExitText: "Si se rescinde antes de 12 meses, el valor económico restante de €1000 vence.",
    earlyExitNote: "Después de la liquidación, no se aplican más pagos de suscripción.",
    postCommitmentTitle: "5. Fase Posterior al Compromiso",
    postCommitmentText: "Después de 12 meses, el acuerdo continúa de mes a mes.",
    postCommitmentNote: "El cliente puede rescindir en cualquier momento sin penalización.",
    lastUpdated: "Última actualización: Febrero 2026"
  },
  cookies: {
    title: "Política de Cookies",
    backToCheckout: "Volver al pago",
    backToHome: "Volver al inicio",
    whatAreCookiesTitle: "Qué son las Cookies",
    whatAreCookiesText: "Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Ayudan al sitio web a recordar información sobre su visita.",
    essentialCookiesTitle: "Cookies Esenciales",
    essentialCookiesText: "Este sitio web utiliza cookies esenciales necesarias para su funcionamiento.",
    essentialCookiesNote: "Estas cookies son necesarias para que el sitio web funcione correctamente y no se pueden desactivar.",
    analyticsCookiesTitle: "Cookies Analíticas",
    analyticsCookiesText: "Las cookies analíticas pueden utilizarse para mejorar el rendimiento y comprender cómo los visitantes interactúan con el sitio web.",
    analyticsCookiesNote: "Estas cookies nos ayudan a analizar el tráfico del sitio web y optimizar la experiencia del usuario.",
    managingCookiesTitle: "Gestión de Cookies",
    managingCookiesText: "Los usuarios pueden desactivar las cookies no esenciales a través de la configuración del navegador.",
    chromeSettings: "Chrome: Configuración → Privacidad y seguridad → Cookies",
    firefoxSettings: "Firefox: Configuración → Privacidad y Seguridad → Cookies",
    safariSettings: "Safari: Preferencias → Privacidad → Cookies",
    disablingNote: "Nota: Desactivar las cookies esenciales puede afectar la funcionalidad del sitio web.",
    thirdPartyCookiesTitle: "Cookies de Terceros",
    thirdPartyCookiesText: "Podemos utilizar servicios de terceros que establecen sus propias cookies:",
    stripeLabel: "Stripe – para el procesamiento de pagos",
    analyticsLabel: "Herramientas de análisis – para el monitoreo del rendimiento",
    updatesTitle: "Actualizaciones de esta Política",
    updatesText: "Podemos actualizar esta Política de Cookies de vez en cuando. Cualquier cambio se publicará en esta página con una fecha de revisión actualizada.",
    contactTitle: "Contacto",
    contactText: "Para preguntas sobre nuestro uso de cookies, póngase en contacto con:",
    lastUpdated: "Última actualización: Febrero 2026"
  }
};
